// Utilidades de CUIT compartidas por el formulario de clientes y la consulta a ARCA.
// Portadas de afip-consulta/index.html para no depender del servidor para validar.

export const limpiarCuit = (cuit) => String(cuit || "").replace(/\D/g, "");

// Digito verificador: modulo 11 sobre los primeros 10 digitos.
export const cuitValido = (cuit) => {
  const limpio = limpiarCuit(cuit);
  if (limpio.length !== 11) return false;

  const pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const suma = pesos.reduce((acumulado, peso, i) => acumulado + peso * +limpio[i], 0);

  let dv = 11 - (suma % 11);
  if (dv === 11) dv = 0;
  if (dv === 10) return false;

  return dv === +limpio[10];
};

export const formatCuit = (cuit) => {
  const limpio = limpiarCuit(cuit);
  if (limpio.length !== 11) return limpio;
  return `${limpio.slice(0, 2)}-${limpio.slice(2, 10)}-${limpio.slice(10)}`;
};

export const tipoPersona = (cuit) => {
  const prefijo = limpiarCuit(cuit).slice(0, 2);
  if (["20", "23", "24", "27"].includes(prefijo)) return "Persona física";
  if (["30", "33", "34"].includes(prefijo)) return "Persona jurídica";
  return "Tipo no estándar";
};
